import { render, staticRenderFns } from "./eddid-bank-account-detail.vue?vue&type=template&id=35073150&"
import script from "./eddid-bank-account-detail.vue?vue&type=script&lang=js&"
export * from "./eddid-bank-account-detail.vue?vue&type=script&lang=js&"
import style0 from "./eddid-bank-account-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "eddid-bank-account-detail.vue"
export default component.exports